/**
 * @file: CreateReservationHeaderButton.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The nav-header "+" on the reservation list: a white circle with a brand plus
 * icon that opens the walk-in (lead-less) create-reservation screen.
 */

import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { ReservationsNavParams } from '@euler/app/flows/reservations';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { Plus } from 'lucide-react-native';
import { memo, useCallback } from 'react';
import { TouchableOpacity } from 'react-native';

export const CreateReservationHeaderButton = memo(() => {
  const { rpx } = useResponsiveContext();
  const navigation =
    useNavigation<StackNavigationProp<ReservationsNavParams>>();
  const onPress = useCallback(() => {
    navigation.navigate('_create', {});
  }, [navigation]);
  return (
    <TouchableOpacity
      activeOpacity={0.7}
      onPress={onPress}
      style={{
        width: rpx(36),
        height: rpx(36),
        borderRadius: rpx(18),
        marginRight: rpx(12),
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: LD.surface,
        shadowColor: '#1B2A44',
        shadowOpacity: 0.08,
        shadowRadius: rpx(6),
        shadowOffset: { width: 0, height: rpx(2) },
        elevation: 2,
      }}
    >
      <Plus size={rpx(20)} color={LD.brand} />
    </TouchableOpacity>
  );
});
